import { jsx as _jsx } from "react/jsx-runtime";
import { VolumeHigh, VolumeLow, VolumeMuted } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Popover } from "@air/primitive-popover";
import { Slider } from "@air/primitive-slider";
import { memo, useCallback, useMemo, useRef, useState } from "react";
import { VOLUME_BUTTON } from "~/constants/testIDs";
export const VolumeControl = /*#__PURE__*/ memo((param)=>{
    let { volume = 0, muted, toggleMuted, onVolumeChange, container } = param;
    const volumeControl = useRef(null);
    const [volumeControlVisible, setVolumeControlVisible] = useState(false);
    const showVolumeControl = ()=>setVolumeControlVisible(true);
    const hideVolumeControl = ()=>{
        setVolumeControlVisible(false);
    };
    const VolumeIcon = useMemo(()=>{
        if (volume === 0 || muted) {
            return VolumeMuted;
        }
        return volume < 0.5 ? VolumeLow : VolumeHigh;
    }, [
        muted,
        volume
    ]);
    const onVolumeButtonClick = useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        toggleMuted();
    }, [
        toggleMuted
    ]);
    return /*#__PURE__*/ _jsx("div", {
        ref: volumeControl,
        className: "relative",
        onMouseLeave: hideVolumeControl,
        children: /*#__PURE__*/ _jsx(Popover, {
            "data-theme": "dark",
            container: container,
            className: "mb-1 ml-1 w-8 min-w-[32px] p-0",
            onOpenChange: setVolumeControlVisible,
            open: volumeControlVisible,
            sideOffset: 0,
            trigger: /*#__PURE__*/ _jsx(IconButton, {
                label: "Volume",
                appearance: "ghost",
                color: "grey",
                size: "large",
                "data-testid": VOLUME_BUTTON,
                onClick: onVolumeButtonClick,
                onMouseEnter: showVolumeControl,
                children: /*#__PURE__*/ _jsx(VolumeIcon, {
                    className: "size-6"
                })
            }),
            children: /*#__PURE__*/ _jsx("div", {
                className: "flex items-center justify-center py-2",
                children: /*#__PURE__*/ _jsx(Slider, {
                    className: "h-20",
                    defaultValue: [
                        volume
                    ],
                    formatTooltip: (values)=>"".concat(Math.round(values[0] * 100), "%"),
                    orientation: "vertical",
                    onValueChange: (value)=>onVolumeChange(value[0]),
                    value: [
                        volume
                    ],
                    step: 0.01,
                    max: 1,
                    min: 0
                })
            })
        })
    });
});
VolumeControl.displayName = "VolumeControl";
